/* global Sys, Services */
Sys.ns("Services");

/**
 * The Ticker Service.
 *
 * @class Services.Ticker
 * @extends Services.Base
 */
Services.Ticker = {
    constructor: function() {
        Services.Ticker.superclass.constructor.apply(this, arguments);

        this._showing = false;
    },

    _setupEvents: function() {
        this.observable.on({
            "request:ticker.show": this.show.bind(this),
            "request:ticker.hide": this.hide.bind(this)
        });
    },

    /**
     * Show the message.
     *
     * @param {Object[]} message The message in segments.
     * @param {string} message.text The text.
     * @param {string} [message.link] The link of the text refers to.
     * @returns {void}
     */
    show: function(message) {
        if (
            Array.isArray(message) &&
            message.length > 0 &&
            message.every(this._validateMessageSegment.bind(this))
        ) {
            this._showing = true;

            this.publish("show", message);
        }
    },

    /**
     * Removes the message.
     *
     * @returns {void}
     */
    hide: function() {
        if (this._showing) {
            this._showing = false;

            this.publish("hide");
        }
    },

    /**
     * Validates message segment.
     *
     * @private
     * @param {Object} segment The segment.
     * @param {string} segment.text The segment text.
     * @returns {boolean} Whether or not the segment is valid.
     */
    _validateMessageSegment: function(segment) {
        return segment && typeof segment.text === "string";
    }
};

Services.Ticker = Sys.extend(Services.Base, Services.Ticker, "Services.Ticker");
